package com.anjuros.website.templates.template8.sections

import androidx.compose.runtime.Composable

import com.anjuros.website.components.shared.AnjurosLogo

import com.anjuros.website.templates.selection.styles.HeaderHeight

import com.anjuros.website.templates.template8.components.Template8Header
import com.anjuros.website.templates.template8.components.Template8MenuCard
import com.anjuros.website.templates.template8.modules.Template8MenuItem
import com.anjuros.website.templates.template8.styles.Template8MenuWidthStyle
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.util.Template8Constants
import com.anjuros.website.templates.template8.util.Template8Res
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun Template8MenuSection(
    modifier: Modifier = Modifier.fillMaxWidth(),
    onMenuCLicked: () -> Unit
) {
    Box(
        modifier = modifier
            .backgroundColor(Template8Theme.Gold3.rgb)
            .fillMaxWidth(),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Template8Header(
                onMenuCLicked = onMenuCLicked
            )
            GoldLine()
            Template8MenuContent()

        }
        AnjurosLogo(
            modifier = Modifier

                .align(Alignment.TopCenter)
                .margin(top = 20.px)
                .size(150.px)
                .objectFit(ObjectFit.ScaleDown),
            src = Template8Res.Image.template8_logo,
            alt = "Pub menu"
        )

    }
}

@Composable
fun Template8MenuContent(){
    Column(
        modifier = Template8MenuWidthStyle.toModifier()
            .margin(top = 100.px, bottom = 50.px),
        verticalArrangement = Arrangement.SpaceBetween,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Template8MenuItem.entries.forEach {  menuCategory ->
            Template8MenuCard(
                menuCard = menuCategory
            )


        }
    }
}

